import cn from 'classnames';

import Icon from 'components/icon/Icon';
import TextInput from '../text-input/TextInput';
import { ISearchInput } from 'source/NFR.types';

interface SearchInputProps extends ISearchInput {
  className?: string;
  idPrefix?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ className, idPrefix, label, name, placeholder }) => (
  <div className={cn('search-input', className)}>
    <Icon className="search-input--icon" name="search" />
    <TextInput
      className="search-input--input"
      idPrefix={idPrefix}
      label={label}
      name={name}
      placeholder={placeholder}
      theme="hiddenLabel"
      type="search"
      value=""
    />
  </div>
);

SearchInput.displayName = 'SearchInput';

export default SearchInput;
